export const VOICE_CDKEY_SAVE = 'VOICE_CDKEY_SAVE';

